import { render, staticRenderFns } from "./paging_page.vue?vue&type=template&id=008a012f&scoped=true&"
import script from "./paging_page.vue?vue&type=script&lang=js&"
export * from "./paging_page.vue?vue&type=script&lang=js&"
import style0 from "./paging_page.vue?vue&type=style&index=0&id=008a012f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008a012f",
  null
  
)

export default component.exports